import React from "react";

const TABS = [
  { key: "all", label: "Recent Users" },
  { key: "completed", label: "Completed Users" },
];

export default function TopUsersTabs({ activeTab, onTabChange }) {
  return (
    <div className="mb-6">
      <div className="border-b border-gray-200 bg-white rounded-t-xl shadow-sm px-2 sm:px-4 pt-3 pb-0">
        <nav className="flex gap-1 flex-wrap" aria-label="Top Users tabs">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => onTabChange(tab.key)}
              className={`px-4 py-2.5 rounded-t-lg font-medium text-sm transition-all duration-200 shrink-0 ${
                activeTab === tab.key
                  ? "bg-red-500 text-white shadow-md -mb-px border border-b-0 border-red-500"
                  : "text-gray-600 hover:bg-gray-100 hover:text-gray-900 border border-transparent"
              }`}>
              {tab.label}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
}
